import { reactive } from "vue"

export const params = reactive({
  regionId: '',
  year: '',
  subsidiaryId: ''
})